import aiTicketSuggestionsImage from "@/assets/images/product-updates/ai-ticket-suggestions.webp";
import alertManagementImage from "@/assets/images/product-updates/alert-management.webp";
import autoTranslationsImage from "@/assets/images/product-updates/auto-translations.webp";
import communityMentionsImage from "@/assets/images/product-updates/community-mentions.webp";
import dashboardContextualHelpImage from "@/assets/images/product-updates/dashboard-contextual-help.webp";
import homeAnnouncementsImage from "@/assets/images/product-updates/home-announcements.webp";
import pollsAnnouncementsImage from "@/assets/images/product-updates/polls-announcements.webp";
import portfolioTicketFiltersImage from "@/assets/images/product-updates/portfolio-ticket-filters.webp";
import requiredTicketMediaImage from "@/assets/images/product-updates/required-ticket-media.webp";
import surveyRemindersImage from "@/assets/images/product-updates/survey-reminders.webp";
import wunderbricksTicketSyncImage from "@/assets/images/product-updates/wunderbricks-ticket-sync.webp";
import type { TranslationKey } from "@/translations";

export const ALERT_MANAGEMENT_UPDATE_ID = "alert-management-2026-09";
export const AUTO_TRANSLATIONS_UPDATE_ID = "auto-translations-2026-07";
export const DASHBOARD_CONTEXTUAL_HELP_UPDATE_ID = "dashboard-contextual-help-2026-08";
export const PORTFOLIO_TICKET_FILTERS_UPDATE_ID = "portfolio-ticket-filters-2026-08";
export const COMMUNITY_MENTIONS_UPDATE_ID = "community-mentions-2026-09";

export type ProductUpdateAction =
  | "create-community-poll"
  | "create-community-post"
  | "create-home-announcement"
  | "manage-alerts"
  | "review-auto-translation-settings"
  | "view-portfolio-tickets";

export type ProductUpdate = {
  id: string;
  publishedAt: string;
  titleKey: TranslationKey;
  descriptionKey: TranslationKey;
  imageAltKey: TranslationKey;
  imageSrc: string;
  autoOpen?: boolean;
  action?: {
    type: ProductUpdateAction;
    labelKey: TranslationKey;
  };
};

export const PRODUCT_UPDATES: ProductUpdate[] = [
  {
    id: ALERT_MANAGEMENT_UPDATE_ID,
    publishedAt: "2026-09-28",
    titleKey: "component.product-updates.alert-management.title",
    descriptionKey: "component.product-updates.alert-management.description",
    imageAltKey: "component.product-updates.alert-management.image-alt",
    imageSrc: alertManagementImage,
    action: {
      type: "manage-alerts",
      labelKey: "component.product-updates.action.manage-alerts",
    },
  },
  {
    id: COMMUNITY_MENTIONS_UPDATE_ID,
    publishedAt: "2026-09-18",
    titleKey: "component.product-updates.community-mentions.title",
    descriptionKey: "component.product-updates.community-mentions.description",
    imageAltKey: "component.product-updates.community-mentions.image-alt",
    imageSrc: communityMentionsImage,
    autoOpen: true,
    action: {
      type: "create-community-post",
      labelKey: "component.product-updates.action.create-community-post",
    },
  },
  {
    id: PORTFOLIO_TICKET_FILTERS_UPDATE_ID,
    publishedAt: "2026-08-31",
    titleKey: "component.product-updates.portfolio-ticket-filters.title",
    descriptionKey: "component.product-updates.portfolio-ticket-filters.description",
    imageAltKey: "component.product-updates.portfolio-ticket-filters.image-alt",
    imageSrc: portfolioTicketFiltersImage,
    action: {
      type: "view-portfolio-tickets",
      labelKey: "component.product-updates.action.view-portfolio-tickets",
    },
  },
  {
    id: DASHBOARD_CONTEXTUAL_HELP_UPDATE_ID,
    publishedAt: "2026-08-28",
    titleKey: "component.product-updates.dashboard-contextual-help.title",
    descriptionKey: "component.product-updates.dashboard-contextual-help.description",
    imageAltKey: "component.product-updates.dashboard-contextual-help.image-alt",
    imageSrc: dashboardContextualHelpImage,
  },
  {
    id: AUTO_TRANSLATIONS_UPDATE_ID,
    publishedAt: "2026-07-27",
    titleKey: "component.product-updates.auto-translations.title",
    descriptionKey: "component.product-updates.auto-translations.description",
    imageAltKey: "component.product-updates.auto-translations.image-alt",
    imageSrc: autoTranslationsImage,
    action: {
      type: "review-auto-translation-settings",
      labelKey: "component.product-updates.action.review-translation-settings",
    },
  },
  {
    id: "ai-ticket-suggestions-2026-07",
    publishedAt: "2026-07-22",
    titleKey: "component.product-updates.ai-ticket-suggestions.title",
    descriptionKey: "component.product-updates.ai-ticket-suggestions.description",
    imageAltKey: "component.product-updates.ai-ticket-suggestions.image-alt",
    imageSrc: aiTicketSuggestionsImage,
  },
  {
    id: "survey-reminders-2026-07",
    publishedAt: "2026-07-08",
    titleKey: "component.product-updates.survey-reminders.title",
    descriptionKey: "component.product-updates.survey-reminders.description",
    imageAltKey: "component.product-updates.survey-reminders.image-alt",
    imageSrc: surveyRemindersImage,
  },
  {
    id: "required-ticket-media-2026-06",
    publishedAt: "2026-06-25",
    titleKey: "component.product-updates.required-ticket-media.title",
    descriptionKey: "component.product-updates.required-ticket-media.description",
    imageAltKey: "component.product-updates.required-ticket-media.image-alt",
    imageSrc: requiredTicketMediaImage,
  },
  {
    id: "wunderbricks-ticket-sync-2026-06",
    publishedAt: "2026-06-12",
    titleKey: "component.product-updates.wunderbricks-ticket-sync.title",
    descriptionKey: "component.product-updates.wunderbricks-ticket-sync.description",
    imageAltKey: "component.product-updates.wunderbricks-ticket-sync.image-alt",
    imageSrc: wunderbricksTicketSyncImage,
  },
  {
    id: "polls-announcements-2026-05",
    publishedAt: "2026-05-29",
    titleKey: "component.product-updates.polls-announcements.title",
    descriptionKey: "component.product-updates.polls-announcements.description",
    imageAltKey: "component.product-updates.polls-announcements.image-alt",
    imageSrc: pollsAnnouncementsImage,
    action: {
      type: "create-community-poll",
      labelKey: "component.product-updates.action.create-poll",
    },
  },
  {
    id: "home-announcements-2026-05",
    publishedAt: "2026-05-15",
    titleKey: "component.product-updates.home-announcements.title",
    descriptionKey: "component.product-updates.home-announcements.description",
    imageAltKey: "component.product-updates.home-announcements.image-alt",
    imageSrc: homeAnnouncementsImage,
    action: {
      type: "create-home-announcement",
      labelKey: "component.product-updates.action.create-announcement",
    },
  },
];

const NEW_UPDATE_WINDOW_IN_DAYS = 30;

export function isProductUpdateNew(publishedAt: string, now = new Date()): boolean {
  const publishedDate = new Date(`${publishedAt}T00:00:00`);
  const ageInMilliseconds = now.getTime() - publishedDate.getTime();

  return ageInMilliseconds >= 0 && ageInMilliseconds <= NEW_UPDATE_WINDOW_IN_DAYS * 24 * 60 * 60 * 1000;
}

export function isProductUpdateUnread(
  update: ProductUpdate,
  readUpdateIds: ReadonlySet<string>,
  now = new Date(),
): boolean {
  return isProductUpdateNew(update.publishedAt, now) && !readUpdateIds.has(update.id);
}
